import React from 'react'

function BethuaMap() {
  return (
    <div>
         <div className="album py-0">
                <div className="container">
                    <div className="row">
                    <iframe className="iframe-fluid mb-3"  height="300" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=BALAJI%20SAREE,%20Patuli%20Ghat%20Rd,%20Bethuadahari,%20West%20Bengal%20741126%20+(BALAJI%20SAREE,%20Patuli%20Ghat%20Rd,%20Bethuadahari,%20West%20Bengal%20741126)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>

                    </div>
                </div>

            </div>
    </div>
  )
}

export default BethuaMap